hrd.dashboard.validationBox = function(options){
	var validationBoxSelector = '#dashboard-validation-layer';
	var validationBoxContentSelector = '#dashboard-validation-layer > span';
	var defaults = {
		title: 'Validation Box',
		text: 'Validation Message',
		okLabel: xlate('common.dialog.ok.btn'),
		width: 600
	};
	options = $.extend({}, defaults, options);

	if(this.$validationBox == null){
		if(!$(validationBoxSelector).exists()){
			var tmpl =  '<div id="dashboard-validation-layer" title="" class="dashboard-msgbox" style="display:none;">' +
						'	<span>' +
						'		<span id="dashboard-validation-layer-icon" class="dashboard-msgbox-icon ui-icon error f-icon fas fa-times-circle"></span>' +
						'		<span id="dashboard-validation-layer-text"></span>' +
						'	</span>' +
						'</div>';
			$('body').append(tmpl);
		}
		this.$validationBox = $(validationBoxSelector);

		this.$validationBox.dialog({
			autoOpen: false,
			resizable: false,
			closable: false,
			dialogClass: 'validation-layer',
			height: 'auto',
			modal: false,
			buttons: [
				{
					id : "dashboard-validation-ok",
					text: options.okLabel,
					click : function(event){
						$(this).dialog("close");
					}
				}
			],
			close: function(event, ui){
				/* reset */
				$('#dashboard-validation-layer-text').html();
				$(document).off('.msgbox');
			},
			open: function(event, ui){
				$(this).height($(validationBoxContentSelector).height() + 'px');

			}
		});
	}

	$('#dashboard-validation-layer-text').html(options.text);
	this.$validationBox.dialog('option', 'title', options.title);
	this.$validationBox.dialog('option', 'width', options.width);
	this.$validationBox.height($(validationBoxContentSelector).height() + 'px');
	this.$validationBox.dialog('open');

	return {
		close: function(){
			this.$validationBox.dialog('close');
		}.bind(this)
	};
}